import { useState } from 'react';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  TextField,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';

interface EditNDInfoProps {
  onSubmit: () => void;
  cpeId: string;
	macAddr: string;
  deviceName: string;
}

export const EditNDInfo = ({ onSubmit, cpeId, macAddr, deviceName }: EditNDInfoProps) => {
  const api = useApi();

  const [newDeviceName, setNewDeviceName] = useState<string>(deviceName);

  const updateName = useMutation(api.editNetworkDeviceNameApiV1EditNetworkDeviceNamePost, {
    onSuccess() {
      toast.success('Device name updated successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const hasChanges = newDeviceName !== deviceName;

  const handleSubmit = () => {
    updateName.mutate({
			node_id: cpeId,
			mac_addr: macAddr,
      device_name: newDeviceName
		});
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Device Name"
        variant="outlined"
        value={newDeviceName}
        onChange={(e) => setNewDeviceName(e.target.value)}
        autoFocus
      />
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={!hasChanges || updateName.isLoading}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
